<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Настройки оповещений</h2>
            </div>
        </div>
        <section>
            <div class="columns">
                <div class="column">
                    <b-tabs expanded type="is-toggle">
                        <b-tab-item expanded label="Sms" icon="message">
                            <div class="columns">
                                <div class="column">
                                    <h2 class="title is-5">Цепочка SMS сообщений</h2>
                                </div>
                                <div class="column">
                                    <b-button class="is-pulled-left"
                                              type="is-primary"
                                              icon-right="plus" @click="createChain('sms')">
                                        Добавить цепочку
                                    </b-button>
                                    <b-button class="is-pulled-right"
                                          type="is-danger"
                                          icon-right="plus"
                                          v-if="selectedChainSms.id && !selectedChainSms.isDefault"
                                          @click="deleteChain(selectedChainSms)">
                                        Удалить цепочку
                                    </b-button>
                                </div>
                            </div>

                          <b-field label="Выберите цепочку" v-if="settings.sms.length > 0">
                            <b-select v-model="selectedChainSms">
                              <option
                                v-for="sms_chain in settings.sms"
                                :value="sms_chain"
                                :key="sms_chain.id">
                                {{ sms_chain.name }}
                              </option>
                            </b-select>
                          </b-field>
                          <div v-if="!selectedChainSms.id" class="mb-4">
                            <b-input placeholder="Название цепочки" v-model="selectedChainSms.name"></b-input>
                          </div>

                          <div v-if="!selectedChainSms.isDefault">
                            <v-divider></v-divider>

                            <b-button
                              v-if="isNewFilter === false"
                              type="is-primary"
                              class="mb-4"
                              @click="isNewFilter = true">
                              Добавить фильтр
                            </b-button>

                            <div v-if="isNewFilter">
                              <!-- Фильтры на цепочку -->
                              <b-field label="Выберите фильтр">
                                <b-select v-model="filter.option" @input="clearDataFilter">
                                  <option
                                    v-for="option in filters_options.filter(option => !this.selectedFiltersSms.includes(option.key))"
                                    :value="option"
                                    :key="option.id">
                                    {{ option.name }}
                                  </option>
                                </b-select>
                              </b-field>

                              <div v-if="filter.option && filter.option.type_filter !== null && filter.option.type_filter !== undefined">
                                <div v-if="[0, 1].includes(filter.option.type_filter)" class="mb-4">
                                  <b-input
                                    class="mb-4"
                                    v-if="filter.variant !== 'empty'"
                                    placeholder="Значение"
                                    :type="(filter.option.type_filter === 1 || filter.option.key === 'id') ? 'number' : 'text'"
                                    v-model="filter.value">
                                  </b-input>

                                  <b-field label="Вариант фильтрации">
                                    <b-select v-model="filter.variant">
                                      <option
                                        v-for="option in filterTypes.filter((f) => f.id === filter.option.type_filter)[0].items"
                                        :value="option.value"
                                        :key="option.id">
                                        {{ option.name }}
                                      </option>
                                    </b-select>
                                  </b-field>
                                </div>

                                <div v-if="filter.option.type_filter === 2" class="mb-4 mt-5">
                                  <b-field :label="filter.option.name">
                                    <b-checkbox v-model="filter.value">
                                      {{ (filter.value) ? 'Да' : 'Нет' }}
                                    </b-checkbox>
                                  </b-field>
                                </div>

                                <div v-if="filter.option.type_filter === 3" class="mb-4">

                                  <v-row>
                                    <v-col>
                                      <b-field label="От">
                                        <b-datepicker
                                          v-model="filter.date.from"
                                          icon="calendar-today"
                                          trap-focus>
                                        </b-datepicker>
                                      </b-field>
                                    </v-col>
                                    <v-col>
                                      <b-field label="До">
                                        <b-datepicker
                                          v-model="filter.date.to"
                                          icon="calendar-today"
                                          trap-focus>
                                        </b-datepicker>
                                      </b-field>
                                    </v-col>
                                  </v-row>

                                </div>
                              </div>

                              <b-button
                                type="is-success"
                                class="mb-4"
                                @click="saveFilter(0)">
                                Сохранить
                              </b-button>
                            </div>

                            <div v-if="selectedChainSms.extra.filters">
                              <div v-if="selectedChainSms.extra.filters.length > 0">
                                <draggable
                                  class="column is-narrow body_table"
                                  v-model="selectedChainSms.extra.filters"
                                  draggable=".draggable-item"
                                  v-bind="dragOptions"
                                >
                                  <transition-group type="transition">
                                    <div
                                      :key="current_filter.id"
                                      v-for="(current_filter, index) in selectedChainSms.extra.filters"
                                      class="draggable-item animate style_table"
                                      style="border-radius: 25px;border: 2px solid #555555; margin-bottom: 5px">
                                      <div class="level">

                                        <div class="level-item column is-3" style="margin-left:10px">
                                          <div>
                                            <p class="name">{{ current_filter.option.name }}</p>
                                          </div>
                                        </div>

                                        <div class="level-item column is-3">
                                          <div>
                                            <p class="name">{{ filterTypes.find(x=>x.id === current_filter.option.type_filter) ? filterTypes.find(x=>x.id === current_filter.option.type_filter).items.find(t=>t.value=current_filter.variant).name : ''}}</p>
                                          </div>
                                        </div>

                                        <div class="level-item column is-3">
                                          <div>
                                            <p class="name">{{ current_filter.value !== null ? current_filter.value : (current_filter.date.from ? 'c ' + new Date(current_filter.date.from).toLocaleDateString() : '') + (current_filter.date.to ? ' до ' + new Date(current_filter.date.to).toLocaleDateString() : '') }}</p>
                                          </div>
                                        </div>

                                        <div class="level-item column">
                                            <div>
                                                <b-button class="button is-danger" icon-right="trash-can" @click="deleteFilter(selectedChainSms, current_filter.id)">
                                                </b-button>
                                            </div>
                                        </div>
                                      </div>

                                      <!-- Соединение И или ИЛИ -->
                                      <div class="level" v-if="index !== selectedChainSms.extra.filters.length - 1">
                                        <div class="level-item column">
                                        </div>

                                        <div class="level-item column is-3">
                                          <div>
                                            <b-select class="px-3" v-model="current_filter.operator" @select="current_filter.operator = $event">
                                              <option
                                                v-for="option in connectors"
                                                value="and"
                                                :value="option.key"
                                                :key="option.key">
                                                {{ option.name }}
                                              </option>
                                            </b-select>
                                          </div>
                                        </div>

                                        <div class="level-item column">
                                        </div>
                                      </div>
                                    </div>
                                  </transition-group>
                                </draggable>
                              </div>

                            </div>
                          </div>

                          <v-divider></v-divider>

                            <div class="columns">
                                <div class="column">
                                    <b-button class="is-pulled-right"
                                              type="is-primary"
                                              icon-right="plus" @click="create(selectedChainSms.linked_chain_settings)">
                                        Добавить этап
                                    </b-button>
                                </div>
                            </div>
                            <div class="columns scrollable" ref="scrollable">
                                <draggable class="column"
                                           v-model="selectedChainSms.linked_chain_settings"
                                           draggable=".draggable-config-call"
                                           v-bind="dragOptions">
                                    <transition-group type="transition" class="timeline">
                                        <div class="draggable-config-call" v-if="selectedChainSms.linked_chain_settings.length > 0" v-for="(sms, index) in selectedChainSms.linked_chain_settings" :key="'key_' + index">
                                            <div class="timeline-item">
                                                <div class="timeline-marker is-icon is-primary"><span>{{index+1}}</span></div>
                                                <div class="timeline-content">
                                                    <div class="columns notification-row is-vcentered">
                                                        <div class="column is-2">
                                                            <div>
                                                                <i class="icon is-medium mdi mdi-dark mdi-menu" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="column">
                                                            <b-field label="Шаблон">
                                                                <b-autocomplete
                                                                  v-model="sms.name"
                                                                  clearable
                                                                  :data="filteredDataArray(templates, sms, 'sms')"
                                                                  :keep-first="false"
                                                                  :open-on-focus="true"
                                                                  field="name"
                                                                  @select="option => (option ? selectedChainSms.linked_chain_settings[index] = getParams(option): selectedChainSms.linked_chain_settings[index] = {name: ''})">
                                                                  <template #empty> Нет результатов </template>
                                                                </b-autocomplete>
                                                            </b-field>
                                                        </div>

                                                        <div class="column is">
                                                            <b-field label="Задержка (ч.)">
                                                                <b-input v-model="sms.pivot.delay"></b-input>
                                                            </b-field>
                                                        </div>

                                                        <div class="column">
                                                            <b-field label="Удалить">
                                                                <b-button class="button is-danger" icon-right="trash-can" @click="remove(selectedChainSms.linked_chain_settings, index)">
                                                                </b-button>
                                                            </b-field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </draggable>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <b-button class="is-pulled-right "
                                              type="is-primary"
                                              @click="save('sms', index)">
                                        Сохранить
                                    </b-button>
                                </div>
                            </div>
                        </b-tab-item>


                        <b-tab-item expanded label="Call" icon="phone">
                            <div class="columns">
                                <div class="column">
                                    <h2 class="title is-5">Цепочка call сообщений</h2>
                                </div>
                                <div class="column">
                                    <b-button class="is-pulled-left"
                                              type="is-primary"
                                              icon-right="plus" @click="createChain('call')">
                                        Добавить цепочку
                                    </b-button>
                                    <b-button class="is-pulled-right"
                                          type="is-danger"
                                          icon-right="plus"
                                          v-if="selectedChainCall.id && !selectedChainCall.isDefault"
                                          @click="deleteChain(selectedChainCall)">
                                        Удалить цепочку
                                    </b-button>
                                </div>
                            </div>

                          <b-field label="Выберите цепочку">
                            <b-select v-model="selectedChainCall">
                              <option
                                v-for="call_chain in settings.call"
                                :value="call_chain"
                                :key="call_chain.id">
                                {{ call_chain.name }}
                              </option>
                            </b-select>
                          </b-field>

                          <div v-if="!selectedChainCall.id" class="mb-4">
                            <b-input placeholder="Название цепочки" v-model="selectedChainCall.name"></b-input>
                          </div>

                          <div v-if="!selectedChainCall.isDefault">
                            <v-divider></v-divider>

                            <b-button
                              v-if="isNewFilter === false"
                              type="is-primary"
                              class="mb-4"
                              @click="isNewFilter = true">
                              Добавить фильтр
                            </b-button>

                            <div v-if="isNewFilter">
                              <!-- Фильтры на цепочку -->
                              <b-field label="Выберите фильтр">
                                <b-select v-model="filter.option" @input="clearDataFilter">
                                  <option
                                    v-for="option in filters_options.filter(option => !this.selectedFiltersCall.includes(option.key))"
                                    :value="option"
                                    :key="option.id">
                                    {{ option.name }}
                                  </option>
                                </b-select>
                              </b-field>

                              <div v-if="filter.option && filter.option.type_filter !== null && filter.option.type_filter !== undefined">
                                <div v-if="[0, 1].includes(filter.option.type_filter)" class="mb-4">
                                  <b-input
                                    class="mb-4"
                                    v-if="filter.variant !== 'empty'"
                                    placeholder="Значение"
                                    :type="(filter.option.type_filter === 1 || filter.option.key === 'id') ? 'number' : 'text'"
                                    v-model="filter.value">
                                  </b-input>

                                  <b-field label="Вариант фильтрации">
                                    <b-select v-model="filter.variant">
                                      <option
                                        v-for="option in filterTypes.filter((f) => f.id === filter.option.type_filter)[0].items"
                                        :value="option.value"
                                        :key="option.id">
                                        {{ option.name }}
                                      </option>
                                    </b-select>
                                  </b-field>
                                </div>

                                <div v-if="filter.option.type_filter === 2" class="mb-4 mt-5">
                                  <b-field :label="filter.option.name">
                                    <b-checkbox v-model="filter.value">
                                      {{ (filter.value) ? 'Да' : 'Нет' }}
                                    </b-checkbox>
                                  </b-field>
                                </div>

                                <div v-if="filter.option.type_filter === 3" class="mb-4">

                                  <v-row>
                                    <v-col>
                                      <b-field label="От">
                                        <b-datepicker
                                          v-model="filter.date.from"
                                          icon="calendar-today"
                                          trap-focus>
                                        </b-datepicker>
                                      </b-field>
                                    </v-col>
                                    <v-col>
                                      <b-field label="До">
                                        <b-datepicker
                                          v-model="filter.date.to"
                                          icon="calendar-today"
                                          trap-focus>
                                        </b-datepicker>
                                      </b-field>
                                    </v-col>
                                  </v-row>

                                </div>
                              </div>

                              <b-button
                                type="is-success"
                                class="mb-4"
                                @click="saveFilter(1)">
                                Сохранить
                              </b-button>
                            </div>

                            <div v-if="selectedChainCall.extra.filters">
                              <div v-if="selectedChainCall.extra.filters.length > 0">
                                <draggable
                                  class="column is-narrow body_table"
                                  v-model="selectedChainCall.extra.filters"
                                  draggable=".draggable-item"
                                  v-bind="dragOptions"
                                >
                                  <transition-group type="transition">
                                    <div
                                      :key="current_filter.id"
                                      v-for="(current_filter, index) in selectedChainCall.extra.filters"
                                      class="draggable-item animate style_table"
                                      style="border-radius: 25px;border: 2px solid #555555; margin-bottom: 5px">
                                      <div class="level">

                                        <div class="level-item column is-3" style="margin-left:10px">
                                          <div>
                                            <p class="name">{{ current_filter.option.name }}</p>
                                          </div>
                                        </div>

                                        <div class="level-item column is-3">
                                          <div>
                                            <p class="name">{{ filterTypes.find(x=>x.id === current_filter.option.type_filter) ? filterTypes.find(x=>x.id === current_filter.option.type_filter).items.find(t=>t.value=current_filter.variant).name : ''}}</p>
                                          </div>
                                        </div>

                                        <div class="level-item column is-3">
                                          <div>
                                            <p class="name">{{ current_filter.value !== null ? current_filter.value : (current_filter.date.from ? 'c ' + new Date(current_filter.date.from).toLocaleDateString() : '') + (current_filter.date.to ? ' до ' + new Date(current_filter.date.to).toLocaleDateString() : '') }}</p>
                                          </div>
                                        </div>

                                        <div class="level-item column">
                                            <div>
                                                <b-button class="button is-danger" icon-right="trash-can" @click="deleteFilter(selectedChainSms, current_filter.id)">
                                                </b-button>
                                            </div>
                                        </div>
                                      </div>

                                      <!-- Соединение И или ИЛИ -->
                                      <div class="level" v-if="index !== selectedChainCall.extra.filters.length - 1">
                                        <div class="level-item column">
                                        </div>

                                        <div class="level-item column is-3">
                                          <div>
                                            <b-select class="px-3" v-model="current_filter.operator" @select="current_filter.operator = $event">
                                              <option
                                                v-for="option in connectors"
                                                value="and"
                                                :value="option.key"
                                                :key="option.key">
                                                {{ option.name }}
                                              </option>
                                            </b-select>
                                          </div>
                                        </div>

                                        <div class="level-item column">
                                        </div>
                                      </div>
                                    </div>
                                  </transition-group>
                                </draggable>
                              </div>

                            </div>

                          </div>
                            <div class="columns">
                                <div class="column">
                                    <b-button class="is-pulled-right"
                                              type="is-primary"
                                              icon-right="plus" @click="create(selectedChainCall.linked_chain_settings)">
                                        Добавить этап
                                    </b-button>
                                </div>
                            </div>

                            <div class="columns scrollable" ref="scrollable">
                                <draggable class="column"
                                           v-model="selectedChainCall.linked_chain_settings"
                                           draggable=".draggable-config-call"
                                           v-bind="dragOptions">
                                    <transition-group type="transition" class="timeline">
                                        <div class="draggable-config-call" v-if="selectedChainCall.linked_chain_settings.length > 0" v-for="(call, index) in selectedChainCall.linked_chain_settings" :key="'key_' + index">
                                            <div class="timeline-item">
                                                <div class="timeline-marker is-icon is-primary"><span>{{index+1}}</span></div>
                                                <div class="timeline-content">
                                                    <div class="columns notification-row is-vcentered">
                                                        <div class="column">
                                                            <div>
                                                                <i class="icon is-medium mdi mdi-dark mdi-menu" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="column">
                                                            <b-field label="Шаблон">
                                                                <b-autocomplete
                                                                  v-model="call.name"
                                                                  clearable
                                                                  :data="filteredDataArray(templates, call, 'call')"
                                                                  :keep-first="false"
                                                                  :open-on-focus="true"
                                                                  field="name"
                                                                  @select="option => (option ? selectedChainCall.linked_chain_settings[index] = getParams(option): selectedChainCall.linked_chain_settings[index] = {name: '', pivot: {delay: 0}})">
                                                                  <template #empty> Нет результатов </template>
                                                                </b-autocomplete>
                                                            </b-field>
                                                        </div>

                                                        <div class="column is">
                                                            <b-field label="Задержка (ч.)">
                                                                <b-input v-model="call.pivot.delay" @input="console.log(call)"></b-input>
                                                            </b-field>
                                                        </div>

                                                        <div class="column">
                                                            <b-field label="Удалить">
                                                                <b-button class="button is-danger" icon-right="trash-can" @click="remove(selectedChainCall.linked_chain_settings, index)">
                                                                </b-button>
                                                            </b-field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </draggable>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <b-button class="is-pulled-right "
                                              type="is-primary"
                                              @click="save('call')">
                                        Сохранить
                                    </b-button>
                                </div>
                            </div>
                        </b-tab-item>
                    </b-tabs>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'NotificationSettings',
  components: {
    draggable,
  },
  created() {
    this.getNotifications();
    this.$store.dispatch('GET_TEMPLATES_LIST');
  },
  data() {
      return {
        selectedChainSms: null,
        selectedChainCall: null,
        channels: [{ id: 'char', name: 'Буква' }, { id: 'digit', name: 'Цифра' }],
        connectors: [
          { key: 'and', name: 'И' },
          { key: 'or', name: 'ИЛИ' },
        ],
        maxIdFilterSms: 0,
        maxIdFilterCall: 0,
        // filters: [],
        isNewFilter: false,
        filter: {
          option: null,
          value: null,
          variant: null,
          date: {
            from: null,
            to: null
          }
        },
        filters_options: [
          {
            id: 1,
            name: 'Дата регистрации',
            key: 'created_at',
            type_filter: 3
          },
          {
            id: 2,
            name: 'ID',
            key: 'id',
            type_filter: 0
          },
          {
            id: 3,
            name: 'Email',
            key: 'email',
            type_filter: 0
          },
          {
            id: 4,
            name: 'Телефон',
            key: 'phone',
            type_filter: 0
          },
          {
            id: 5,
            name: 'Utm_source',
            key: 'utm_source',
            type_filter: 0
          },
          {
            id: 6,
            name: 'Utm_campaign',
            key: 'utm_campaign',
            type_filter: 0
          },
          {
            id: 7,
            name: 'СМС Бан?',
            key: 'is_sms_blocked', // !!!!
            type_filter: 2
          },
          {
            id: 8,
            name: 'Звонки Бан?',
            key: 'is_call_blocked', // !!!!
            type_filter: 2
          },
          {
            id: 9,
            name: 'СМС White list?',
            key: 'is_sms_white', // !!!!
            type_filter: 2
          },
          {
            id: 10,
            name: 'Звонки White list?',
            key: 'is_call_white', // !!!!
            type_filter: 2
          },
          {
            id: 11,
            name: 'Количество регистраций',
            key: 'count_reg',
            type_filter: 1
          },
          {
            id: 12,
            name: 'aff_sub1',
            key: 'aff_sub1',
            type_filter: 0
          },
          {
            id: 13,
            name: 'aff_sub2',
            key: 'aff_sub2',
            type_filter: 0
          },
          {
            id: 14,
            name: 'aff_sub3',
            key: 'aff_sub3',
            type_filter: 0
          },
          {
            id: 15,
            name: 'aff_sub4',
            key: 'aff_sub4',
            type_filter: 0
          },
          {
            id: 16,
            name: 'aff_sub5',
            key: 'aff_sub5',
            type_filter: 0
          },
        ],
        filterTypes: [
          {
            id: 0,
            items: [
              {
                id: 0,
                name: 'Содержит',
                value: 'contains'
              },
              {
                id: 1,
                name: 'Не содержит',
                value: 'not contains'
              },
              {
                id: 2,
                name: 'Пустое',
                value: 'empty'
              },
              {
                id: 3,
                name: 'Совпадает',
                value: 'equal'
              }
            ]
          },
          {
            id: 1,
            items: [
              {
                id: 0,
                name: 'Больше',
                value: 'more'
              },
              {
                id: 1,
                name: 'Меньше',
                value: 'less'
              },
              {
                id: 2,
                name: 'Совпадает',
                value: 'equal'
              }
            ]
          },
        ]
      };
  },
  computed: {
    settings() {
      return this.$store.getters.NOTIFICATION_SETTINGS;
    },
    isLoading() {
      return this.$store.getters.SET_NOTIFICATION_SETTINGS_LOADING;
    },
    dragOptions() {
      return {
        animation: 200,
        scroll: true,
        scrollSensitivity: 100,
        scrollSpeed: 10,
      };
    },
    templates() {
        return this.$store.getters.TEMPLATES_LIST.results;
    },
    selectedFiltersSms() {
      return this.selectedChainSms.extra.filters.map(entry => entry.option.key);
    },
    selectedFiltersCall() {
      return this.selectedChainCall.extra.filters.map(entry => entry.option.key);
    },
  },
  methods: {
    create(currentChain) {
      currentChain.push({ name: '', pivot: {delay: 0}});
    },
    createChain(type) {
      switch (type) {
        case 'sms':
          this.selectedChainSms = {
            name: '', type: 'sms', extra: {filters: []}, linked_chain_settings: [], id: null,
          };
          this.maxIdFilterSms = 0;
          break;
        case 'call':
          this.selectedChainCall = {
            name: '', type: 'call', extra: {filters: []}, linked_chain_settings: [], id: null,
          };
          this.maxIdFilterCall = 0;
          break;
      }
    },
    remove(currentChain, index) {
      currentChain.splice(index, 1);
    },
    save(type) {
        const params = {
            settings: type ==='sms' ? this.selectedChainSms : this.selectedChainCall,
        };
      this.$store.dispatch('SAVE_NOTIFICATION_SETTINGS', params)
        .then(() => {
          this.getNotifications();
          this.$toaster.success('Настройки сохранены');
        })
        .catch(() => {
          this.$toaster.error('Неизвестная ошибка');
        });
    },
    filteredDataArray(data, item, type) {
        return data.filter((option) => {
          return option.name
              .toString()
              .toLowerCase()
              .indexOf(item.name.toLowerCase()) >= 0 && (type ? option.type === type : 1)
        })
    },
    // type 0 - sms, 1 - call
    saveFilter(type) {
      let thisChain = type === 0 ? this.selectedChainSms.extra : this.selectedChainCall.extra;
      this.filter['operator'] = null;
      this.isNewFilter = false;
      if (type === 0) {
        this.filter['id'] = this.maxIdFilterSms++;
      } else if (type === 1) {
        this.filter['id'] = this.maxIdFilterCall++;
      }

      this.filter['operator'] = 'and';

      if (thisChain.filters === undefined) {
        thisChain.filters = [];
      }
      thisChain.filters.push(this.filter);

      this.clearDataFilter();
    },
    clearDataFilter() {
      this.filter = {
        option: this.filter.option,
        value: null,
        variant: null,
        date: {
          from: null,
          to: null
        }
      };
    },
    deleteFilter(currentSetting, id_filter) {
      let index = currentSetting.extra.filters.findIndex(filter => filter.id === id_filter);
      if (index !== -1) {
        currentSetting.extra.filters.splice(index, 1);
      }
    },
    deleteChain(currentSetting){
        this.$store.dispatch('DELETE_CHAIN', currentSetting.id)
            .finally(() => this.getNotifications());
    },
    getParams(option) {
        option['pivot'] = {delay: 0};
        return option;
    },
    getNotifications(){
        this.$store.dispatch('GET_NOTIFICATION_SETTINGS')
        .then(() => {
            this.selectedChainSms = this.settings.sms[0] || {
              name: '', type: 'sms', extra: {filters: []}, linked_chain_settings: [], id: null,
            };

            if (this.selectedChainSms.extra.filters === undefined) {
              this.selectedChainSms.extra.filters = [];
            } else {
              let maxIdFilter = Math.max(...this.selectedChainSms.extra.filters.map(entry => entry.id), null);
              if (maxIdFilter !== null) {
                this.maxIdFilterSms = ++maxIdFilter;
              }
            }

            this.selectedChainCall = this.settings.call[0] || {
              name: '', type: 'call', extra: {filters: []}, linked_chain_settings: [], id: null,
            };

            if (this.selectedChainCall.extra.filters === undefined) {
              this.selectedChainCall.extra.filters = [];
            } else {
              let maxIdFilter = Math.max(...this.selectedChainCall.extra.filters.map(entry => entry.id), null);
              if (maxIdFilter !== null) {
                this.maxIdFilterSms = ++maxIdFilter;
              }
            }
          });
    },
  },
};
</script>

<style>
    .tabs.is-toggle li.is-active a {
        background-color: #1d8f68;
    }
    .notification-row {
        background-color: #fff;
        border: solid 1px #cecece;
        border-radius: 5px;
        padding: 10px;
    }
</style>
